import styled from "styled-components";

export const CustomEditStyled = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;
    justify-content: space-between;

    .input{
        width: 100%;
    }

    .p-dropdown-label {
        line-height: 1;
        padding: 8px 16px;
    }
`